import React from "react";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import { Image } from "react-bootstrap";

const PaymentSuccess = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const transactionId = params.get("transactionId");
  const amount = params.get("amount");

  const secretKey = process.env.REACT_APP_CRYPTJS_SECRET_KEY;

  const decryptValue = (encryptedValue) => {
    try {
      if (!encryptedValue || !secretKey) return null;

      const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
      const originalValue = bytes.toString(CryptoJS.enc.Utf8);

      return originalValue || null;
    } catch {
      return null;
    }
  };

  const decryptedTrnxNo = decryptValue(decodeURIComponent(transactionId));
  const decryptedAmount = decryptValue(decodeURIComponent(amount));

  return (
    <div className="payment-failed-content--detail page-height ">
      <Image
        alt="payment-success"
        className="payment-success-image"
        src="/images/payment-success.svg"
      />

      <h2 className="pay-success">
        <strong>Thank you</strong>
      </h2>

      <h4 className="pay-success">
        Your payment has been processed successfully.
      </h4>

      <ul className="payment-success-list">
        <li>
          <strong>Transaction No:</strong> {decryptedTrnxNo}
        </li>
        <li>
          <strong>Amount Paid:</strong>{" "}
          {new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
          }).format(decryptedAmount / 100)}
        </li>
      </ul>
    </div>
  );
};

export default PaymentSuccess;
